import CartItemsTab from './CartItemsTab';

export default CartItemsTab;
